module.exports = __webpack_public_path__ + "static/img/yixishop.55279dc9.png";